/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'pip-model',
    'pip-events'
],
function homeServicesCoordinator(
    $,
    pip,
    pipEvents
) {
    var ASSEMBLY_SERVICE_TYPE= 'Assembly';
    var INSTALL_SERVICE_TYPE = 'Install';
    var NOT_DISPLAYED = 'notDisplayed';
    var KITCHEN_CABINETS_GUID = 'c07de5b6-4f80-4dda-972e-33c2400309a6'; 

    var model = {
        homeServicesAddOnAvailability: {
            isAvailable: false
        },
        getData: function getData(zipCode) {
            var show = '&show=doitforme,doityourself';
            var params = {
                installSkus: pip.serviceAddOns.attachLabor.installationSku,
                storeId: pip.customer.localStore.storenumber,
                itemId: pip.products.primary.data.itemId,
                key: 'tmUwNSh4jVZ4YzcMSlEM9xFGADJJx291'
            };

            if (zipCode) {
                delete params.storeId;
                params.zipCode = zipCode;
            } 
            
            var url = '/installSkuInfo/v1?' + $.param(params, true) + show;

            return $.ajax({
                type: "GET",
                url: url
            })
        },
        init: function initModel(zipCode) {
            model.homeServicesAddOnAvailability.isAvailable = false;
            pip.installationSku = null;       
            model.getData(zipCode).done(function(data) {  
                if (model.isInstallationSkuAvailable(data)) {
                    model.homeServicesAddOnAvailability.isAvailable = true;
                    model.updateInstallationData(data)
                } 
            }).fail(function(e) {
                if (pip.debugMode) {
                    console.error('Failed to load home services model:', e);
                }
            }).always(function() {
                if (zipCode) {
                    pipEvents.attachLabor.newZipCodeProcessed.trigger(model.homeServicesAddOnAvailability)
                }
                pipEvents.pipLifecycleEvents.attachLabor.attachLaborProcessed.trigger(model.homeServicesAddOnAvailability);
            });
        },
        isInstallationSkuAvailable: function isInstallationSkuAvailable(data) {
            return !!(data
                && data.installSkus
                && data.installSkus[0] 
                && data.installSkus[0].installRetailPrice
                && data.installSkus[0].installRetailPrice.price
                && data.installSkus[0].eligibility
                && !data.installSkus[0].eligibility.errorCode
                && data.installSkus[0].eligibility.isInstallAvailable
                && data.installSkus[0].serviceType
                &&  (viewModel.isSellableAssemblyDisplayable(data.installSkus[0].serviceType) || viewModel.isSellableInstallationDisplayable(data.installSkus[0].serviceType)))
        },
        updateInstallationData: function updateInstallationData(data) {
            pip.installationSku = data.installSkus[0];
            pip.installationSku.doItYourself = data.doItYourself && data.doItYourself[0];
            pip.installationSku.isInstall = viewModel.isSellableInstallationDisplayable(data.installSkus[0].serviceType);
            pip.installationSku.isAssembly = viewModel.isSellableAssemblyDisplayable(data.installSkus[0].serviceType);
        }
    };

    var viewModel = {
        isSellableAssemblyDisplayable: function isSellableAssemblyDisplayable(serviceType) {
            return (serviceType === ASSEMBLY_SERVICE_TYPE);
        },
        isSellableInstallationDisplayable: function isSellableInstallationDisplayable(serviceType) {
            return (serviceType === INSTALL_SERVICE_TYPE);
        }
    };

    var view = {
        initEventListeners: function initEventListeners() {
            pipEvents.attachLabor.zipCodeChanged.off('.home-services-coordinator');
            pipEvents.attachLabor.zipCodeChanged.on('.home-services-coordinator' , function(e, zipCode) {
                model.init(zipCode);
            })
        }
    };

    function setIsCustomKitchenCabinetsFlag() {
        var isCustomKitchenCabinets;
        var notDisplayedAttributeGroup = pip.products.primary.data.attributeGroups.filter(function (attrs) {
            return attrs.groupType === NOT_DISPLAYED;
        })[0];

        if (notDisplayedAttributeGroup) {
            isCustomKitchenCabinets = !!(notDisplayedAttributeGroup.entries.filter(function (entry) {
                return entry.value === KITCHEN_CABINETS_GUID;
            }).length);
        }
        pip.setFlag('isCustomKitchenCabinets', isCustomKitchenCabinets);
    }

    return {
        init: function init() {
            setIsCustomKitchenCabinetsFlag();
            if (!this.shouldCallService()) {
                pipEvents.pipLifecycleEvents.attachLabor.attachLaborProcessed.trigger(model.homeServicesAddOnAvailability);
                return;
            }
            model.init();
            view.initEventListeners();
        },
        model: model,
        viewModel: viewModel,
        shouldCallService: function shouldCallService() {
            return !!(pip.features
                && pip.features.attachLaborFeatureEnabled
                && !pip.isB2BCustomer
                && pip.fulfillment
                && pip.fulfillment.shipping
                && pip.fulfillment.shipping.shipToHome
                && pip.serviceAddOns
                && pip.serviceAddOns.attachLabor
                && pip.serviceAddOns.attachLabor.installationSku)
        },
        setIsCustomKitchenCabinetsFlag: setIsCustomKitchenCabinetsFlag
    }
});

}.call(window));